import React, { useRef, useEffect, useState } from "react";
import ReactPlayer from "react-player";

interface AutoPlayVideoProps {
  url: string; // Typ der Prop für die URL
}

const AutoPlayVideo: React.FC<AutoPlayVideoProps> = ({ url }) => {
  const [shouldPlay, setShouldPlay] = useState(false);
  const playerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const videoElement = playerRef.current;
      if (videoElement) {
        const top = videoElement.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (top < windowHeight * 0.8 && !shouldPlay) {
          setShouldPlay(true);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [shouldPlay]);

  return (
    <div
      className="h-full w-full flex-col rounded-xl bg-[#F0EFF4] shadow-xl"
      ref={playerRef}
    >
      <div className="h-1/6 w-full rounded-tl-xl rounded-tr-xl border-b-2 border-b-gray-200 bg-[#FFFFFF]">
        <svg
          className="ml-2"
          width="80"
          height="18"
          viewBox="0 0 203 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="17.5" cy="17.5" r="17.5" fill="#5C9987" />
          <circle cx="101.5" cy="17.5" r="17.5" fill="#F3A42E" />
          <circle cx="185.5" cy="17.5" r="17.5" fill="#FF7676" />
        </svg>
      </div>
      <div
        className="-mb-4 h-5/6 w-full
                    sm:-mb-0
                    md:-mb-0
                    lg:-mb-0
                    xl:-mb-0
                    "
      >
        <ReactPlayer
          url={url} // Verwende die dynamische URL aus der Prop
          volume={0}
          playing={shouldPlay}
          controls={false}
          loop={true}
          playbackRate={0.75}
          width={"100%"}
        ></ReactPlayer>
      </div>
    </div>
  );
};

export default AutoPlayVideo;
